module.exports = __webpack_public_path__ + "img/1697158439974-WhatsApp Image 2023-10-13 at 08.50.29.jpeg.caa2f20f.webp";